import React from 'react';
import AppLayout from 'modules/AppLayout/AppLayout';
import PropTypes from 'prop-types';

function MainLayout({ children, routes = [] }) {
  return <AppLayout routes={routes}>{children}</AppLayout>;
}

MainLayout.defaultProps = {
  routes: [],
};

MainLayout.propTypes = {
  children: PropTypes.element.isRequired,
  routes: PropTypes.arrayOf(),
};

export default MainLayout;
